module.exports = __webpack_public_path__ + "kudos_27.svg?acc1f03613be0b5f848c951b127d8c78";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_27.svg
// module id = 125
// module chunks = 0